import { all, takeLatest, call, put } from "redux-saga/effects";
import actions from "./actions";
import { postLeadMarketToken } from "@src/services/personalLoanApi";

function* submitLeadMarket( payload ) {
  try {               
    const response = yield call(postLeadMarketToken, payload);         
    yield put(actions.submitLeadMarketSuccess(response.data.Data.Lead_Token)); 
  } catch (e) {        
    yield put(actions.submitLeadMarketFailed());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.RETRIEVE_LEADMARKET_LEAD_TOKEN_START, submitLeadMarket),
  ]);
}
